import { Httpcommon, HttpcommonToken } from "../../../shared/api/axiosClient";
import { BannerResult, BillerResult, TokenRequest, TokenResult, TypeResult } from "../domain/entities/Main";
import MainRepository from "../domain/repositories/MainRepository";
import { Buffer } from 'buffer';

export default class MainApi implements MainRepository {
  async token(body: TokenRequest): Promise<TokenResult> {
    return await HttpcommonToken.post<TokenResult>(`/token`, {
      ...body,
    }).then((res) => res.data);
  }
  async getBiller(): Promise<BillerResult> {
    return await Httpcommon.get<BillerResult>(`biller`).then((res) => res.data);
  }
  async getBannerPath(): Promise<BannerResult> {
    return await Httpcommon.get<BannerResult>(`banner`, {
      params: { page: "Home_page" },
    }).then((res) => res.data);
  }
  async getBannerImg(path: string): Promise<any> {
    return await Httpcommon.get<any>(`image`, {
      params: { path: path },
    }).then((res) => res.data);
  }
  async getImagePath(path: string): Promise<any> {
    return await Httpcommon.get<any>(`/portal/image`, {
      params: { path: path },
      responseType: "arraybuffer",
    }).then(
      (res) =>
        `data:${res.headers["content-type"]};base64,${Buffer.from(
          res.data,
          "binary"
        ).toString("base64")}`
    );
  }
  async getListType(): Promise<TypeResult> {
    return await Httpcommon.get<TypeResult>(`biller/type`).then((res) => res.data);
  }
  async getFaq(partnerId: string): Promise<any> {
    return await Httpcommon.get<any>(`faq`, {
      params: { partnerId: partnerId },
    }).then((res) => res.data);
  }
}
